<script setup>

</script>

<template>
  <div>
    <div class="shadow bg-white rounded-[20px] text-center items-center font-semibold flex flex-col p-[24px]">
      <p class="text-[24px] text-brand-green mb-[10px]" style="line-height: 32px;">
        Kupujete 3 a více vstupenek?
      </p>
      <p class="text-[16px] font-medium mb-[30px] max-w-[600px] text-[#666]" style="line-height: 24px;">
        Staňte se partnerem ShopCampu a získejte navíc možnost oslovení účastníků v e-mailingu, vizibilitu na místě i
        online a další výhody.
      </p>
      <div class="flex justify-center">
        <a class="text-[20px] text-white font-semibold rounded-full px-[49px] py-[16px] bg-brand-green"
           href="mailto:sara@shopcamp.cz">Ozvěte se na <span class="underline">sara@shopcamp.cz</span></a>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
